module.exports = __webpack_public_path__ + "img/trustpilot-horizontal.f82004dc.png";